<div
  id="mathlive"
  class="math-field"
  #mathField
  [attr.lang]="getLanguage()"
  [attr.role]="isLocked && ariaLabel ? 'img' : null"
  [attr.aria-label]="isLocked && ariaLabel ? screenReaderText || ariaLabel : null"
></div>
<span
  *ngIf="ariaLabel && screenReaderTextId"
  class="sr-only"
  role="status"
  aria-live="polite"
  aria-atomic="true"
  [attr.lang]="getLanguage()"
  [id]="screenReaderTextId"
>{{screenReaderText}}</span>
<!--<div [attr.hidden]="!isLocked ? true : undefined" class="math-field">{{this.getValue()}}</div>-->
